import { ProductMembershipsCurriculumCompletionFilter } from "@/admin/insights/member-reports/tabs/products/__generated__/AdminMembersReportProductsTableExportCSVButtonMutation.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import { SelectOption } from "@disco-ui"
import DiscoTableFilterDropdown from "@disco-ui/table/header/search/DiscoTableFilterDropdown"
import { TestIDProps } from "@utils/typeUtils"

type AdminMembersReportProductsTableCurriculumCompletionOption =
  SelectOption<ProductMembershipsCurriculumCompletionFilter | null>

export type AdminMembersReportProductsTableCurriculumCompletionFilterState = {
  curriculumCompletion: AdminMembersReportProductsTableCurriculumCompletionOption | null
}

interface AdminMembersReportProductsTableCurriculumCompletionFilterProps
  extends TestIDProps {
  filterState: AdminMembersReportProductsTableCurriculumCompletionFilterState
  setFilterState: (
    state: AdminMembersReportProductsTableCurriculumCompletionFilterState
  ) => void
}

function AdminMembersReportProductsTableCurriculumCompletionFilter({
  filterState,
  setFilterState,
}: AdminMembersReportProductsTableCurriculumCompletionFilterProps) {
  const labels = useLabels()
  const options: AdminMembersReportProductsTableCurriculumCompletionOption[] = [
    { value: null, title: "All" },
    { value: "ongoing", title: "Ongoing progress" },
    { value: "completed", title: "Completed" },
  ]

  return (
    <DiscoTableFilterDropdown
      testid={"AdminMembersReportProductsTableCurriculumCompletion.product-select"}
      isNested
      options={options}
      onOptionSelect={(curriculumCompletion) => setFilterState({ curriculumCompletion })}
      selectedOption={filterState.curriculumCompletion}
      dropdown={{
        label: `${labels.curriculum.singular} Completion`,
      }}
    />
  )
}

export default AdminMembersReportProductsTableCurriculumCompletionFilter
